import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, LoadMore, Button, MediaBox } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Download from 'components/download.js';
import SearchBar from '../components/searchbar';
import { Link } from 'react-router-dom';
import PriceCompare from 'components/priceCompare';
import OrderLogList from 'components/orderLogList';
import Big from 'big.js';
import CommonFns from 'functions/common.ts';
//单头自定义字段
import HeadCustField from 'components/headCustField';
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';

function InquiryDetail(props) {
  const Config = {
    purchase: {
      title: '供应商询价招标详情',
      apiPath: '/inquiry/Order/getDetail',
      publishApiPath: '/inquiry/Order/publish',
      cancelApiPath: '/inquiry/Order/cancel',
      finishApiPath: '/inquiry/Order/finish',
      finishApplyApiPath: '/inquiry/Order/finishApply',
      completeApiPath: '/b2bPriceCompareOrder/terminate', //有比价单的终止询价
      completeApiPath2: '/inquiry/Order/manualFinish', //没有比价单的终止询价
      puResultApiPath: '/b2bPriceCompareOrder/sendResult', //有比价单的发布结果
      puResultApiPath2: '/inquiry/vendorQuoteOrder/sendQuote', //没有比价单的发布结果
      compareStartApiPath: '/inquiry/Order/startPriceCompare', //开始比价
      enumMainKey: 'B02_Inquiry_Status',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      custFieldBillType: 51, //自定义字段单别
      detailLink: '/mp/purchase/inquiry/prod/quote/detail',
      pcDetailLink: '/mp/purchase/inquiry/quote-compare/detail',
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'inqXkNo',
      quoteName: '报价'
    },
    sale: {
      title: '客户询价招标详情',
      apiPath: '/inquiry/customerOrder/getDetail',
      enumMainKey: 'B02_Inquiry_Status',
      companyCodeKey: 'customerCode',
      companyNameKey: 'innerCustomerName',
      custFieldBillType: 51, //自定义字段单别
      addLink: '/mp/sale/inquiry/prod/quote/add',
      detailLink: '/mp/sale/inquiry/prod/quote/detail',
      quotePublishApiPath: '/inquiry/quoteOrder/publish', //发布报价
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Quote_Status',
          subKey: 'qouteStatus',
          value: 'qouteStatusName'
        }
      ],
      idField: 'inqXkNo',
      quoteName: '报价'
    }
  };

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    fieldSetting,
    forceUpdate,
    setWorkflow,
    self
  } = useDetail(props, config);
  self.idField = 'inqXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  const [boxState, setBoxState] = useState({
    1: true
  });

  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [takeNotesList, setTakeNotesList] = useState([]); //报价列表前端搜索的完整列表数据
  const [takeNotesList1, setTakeNotesList1] = useState([]); //报价列表前端搜索的当前列表数据
  const [quoteList, setQuoteList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [searchKey, setSearchKey] = useState('');
  const [upSetFlag, setUpSetFlag] = useState(false);
  const [fieldSetting1, setFieldSetting1] = useState({
    headCustList: [],
    bodyCustList: []
  }); //自定义字段设置
  // const [workflowData, setWorkflowData] = useState({});

  //处理详情数据
  self.afterGetDetail = async function (data) {
    EnumService.getValue('B02_Inquiry_Bill_Type', data.billType).then(value => {
      data.billTypeName = value;
      forceUpdate();
    });
    data.prodList.forEach(item => {
      EnumService.getValue('B02_Inquiry_Bill_Type', item.billType).then(
        value => {
          item.billTypeName = value;
          forceUpdate();
        }
      );
      // descTag （Integer） 来源单据描述标识：0:手填或已选物料；1：导入自定义标题属性 默认0；
      // sourceOrderType 来源单据类型 0:商机；1：内部询价单
      if (item.descTag === 1 && !Util.isEmpty(item.description)) {
        item.descriptionList = showItemsDes(item.description);
      }
      Util.genExtendFields(item);
    });
    if (data.billType === 2) {
      config.quoteName = '投标';
    }

    data.taxRate = data.taxRate * 100;
    data.priceContainTaxName =
      data.priceContainTaxFlag === 0
        ? '不限'
        : data.priceContainTaxFlag === 1
        ? '含税价'
        : '未税价';
    if (props.type === 'sale') {
      getQuoteList(data);
    } else {
      if (data.billType === 1) {
        setWorkflow({ wfmCode: '1004' });
      } else {
        setWorkflow({ wfmCode: '1023' });
      }
      data.fileMd5s = data.fileMd5s || [];
      data.quoteCurrencyName = data.quoteCurrencyName || '人民币'; //默认人民币
    }
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    if (fieldSetting.bodyCustList.length > 0) {
      fieldSetting.bodyCustList = fieldSetting.bodyCustList?.filter(item =>
        item.fieldCode.includes('platform')
      );
      setFieldSetting1(fieldSetting);
      if (!upSetFlag) {
        self.getDetail();
        setUpSetFlag(true);
      }
    }
  }, [fieldSetting, self, upSetFlag]);

  // //根据审批编码执行审批流初始化
  // useEffect(() => {
  //   self.initWorkflow(workflowData);
  // }, [self, workflow, workflowData]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      inqXkNo: detail.inqXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
    if (Number(type) === 1 && self.isPurchase) {
      getPurchaseList();
    }
    if (
      ((detail.status > 3 && detail.status !== 8) ||
        (detail.status === 8 && detail.billType === 1)) &&
      self.isPurchase &&
      detail.pcXkNo
    ) {
      if (Number(type) === 2 && self.isPurchase) {
        getCompareList();
      }
    }
  }

  // 导入清单的物料,(相关说明显示)
  function showItemsDes(description) {
    let obj = JSON.parse(description);
    // 物料群组为空
    let title = !Util.isEmpty(obj.customTitle)
      ? obj.customTitle.split(',')
      : [];
    let value = !Util.isEmpty(obj.customValue)
      ? obj.customValue.split(',')
      : [];
    let arr = [];
    if (!Util.isEmpty(title)) {
      title.forEach((item, index) => {
        if (!Util.isEmpty(item)) {
          arr.push({ text: value[index] || '', title: item });
        }
      });
    }
    return arr;
  }

  //查看附件
  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = businessType === 119 ? obj.uniqueKey : detail.inqXkNo,
      xkNo = obj.inqXkNo,
      lineNo = obj.lineNo,
      cCode = detail[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });

    actions.openDownloadModal();
  }

  // 获取报价比价列表
  function getPurchaseList() {
    let postbody = {
      apiPath: '/inquiry/vendorQuoteOrder/list',
      inqXkNo: self.id,
      searchKey: searchKey,
      orderProperty: 'createTime',
      ascOrDesc: 'desc',
      companyCode: companyCode
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data.list || [];
        list.forEach(item => {
          EnumService.getValue('B02_Quote_Status', item.status).then(value => {
            item.statusName = value;
            forceUpdate();
          });
        });
        setTakeNotesList(list);
        setTakeNotesList1(list);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //获取报价对比列表
  //viewType 视图类型 1：物料模式, 2:供应商模式  默认：物料模式
  function getCompareList() {
    let inqLineNos = [];
    let batchEmployees = [];
    if (Array.isArray(detail.prodList)) {
      detail.prodList.forEach(item => {
        inqLineNos.push(item.lineNo);
      });
    }
    let postbody = {
      companyCode: companyCode,
      inqXkNo: detail.inqXkNo,
      pcXkNo: detail.pcXkNo,
      inqLineNos: inqLineNos,
      orderProperty: 'createTime',
      ascOrDesc: 'desc',
      viewType: 1,
      apiPath: '/b2bPriceCompareOrder/comparePrint'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        if (
          !response.data ||
          (Array.isArray(response.data) && response.data.length === 0)
        ) {
          ModalService.showInfo('暂无报价记录', dispatch);
          return;
        }
        let data = response.data.pageLineList.list || [];
        data.forEach(item => {
          item.activeFlag = true;
          if (Array.isArray(item.detailList)) {
            item.detailList.forEach(line => {
              //判断是否含税,价格是否含税 0:不限；1:含税价；2:未税价; 默认值:0"，不限时，税率为0则未税
              if (line.priceContainTaxFlag === 0) {
                if (line.taxRate > 0) {
                  line.priceContainTaxFlagShow = '含税';
                } else {
                  line.priceContainTaxFlagShow = '不含税';
                }
              } else if (line.priceContainTaxFlag === 1) {
                line.priceContainTaxFlagShow = '含税';
              } else if (line.priceContainTaxFlag === 2) {
                line.priceContainTaxFlagShow = '不含税';
              } else {
                line.priceContainTaxFlagShow = '不含税';
              }
              line.taxRateShow = !Util.isEmpty(line.taxRate)
                ? parseFloat(Big(line.taxRate).times(100).valueOf())
                : undefined; //按百分比显示税率
              //计算报价金额
              line.quoteAmountTotal = line.subList?.length ? 0 : undefined;
              if (Array.isArray(line.subList)) {
                line.subList.forEach(quote => {
                  if (
                    Util.isBig(quote.quoteAmount) &&
                    Util.isBig(line.quoteAmountTotal)
                  ) {
                    line.quoteAmountTotal = Number(
                      Big(line.quoteAmountTotal)
                        .plus(quote.quoteAmount)
                        .valueOf()
                    );
                  }
                  if (
                    Util.isBig(quote.quoteBaseAmount) &&
                    Util.isBig(line.quoteBaseAmountTotal)
                  ) {
                    line.quoteBaseAmountTotal = Number(
                      Big(line.quoteBaseAmountTotal)
                        .plus(quote.quoteBaseAmount)
                        .valueOf()
                    );
                  }
                });
                line.quoteAmountString = line.subList
                  .map(quote => quote.quoteAmount)
                  .join(',');
                line.quoteBaseAmountString = line.subList
                  .map(quote => quote.quoteBaseAmount)
                  .join(',');
              }
            });
          }
        });
        detail.quoteCompareList = data;
        setDetail(detail);
        forceUpdate();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  function handleSearchReset() {
    setTakeNotesList(takeNotesList);
    setPageNum(1);
    setShowLoading(true);
    getPurchaseList();
  }

  function handleSearchChange(text, e) {
    e.preventDefault();
    setSearchKey(text);
    handleSearchReset();
  }

  function handleSearchClear() {
    setSearchKey('');
    handleSearchReset();
  }
  //前端搜索过滤
  function handleSearch(key, e) {
    let arrSearchField = ['innerVendorCode', 'innerVendorName']; //搜索字段
    let searchKey1 = key;
    let listFilter = Util.listSearch(takeNotesList, searchKey1, arrSearchField);
    setTakeNotesList1(listFilter);
  }

  //获取报价列表
  function getQuoteList(data) {
    let postbody = {
      inqXkNo: self.id,
      companyCode: companyCode,
      apiPath: '/inquiry/quoteOrder/list'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data.list || [];
        list.forEach(item => {
          EnumService.getValue('B02_Quote_Status', item.status).then(value => {
            item.statusName = value;
            forceUpdate();
          });
        });
        parseCustomInquiryDetail(data, list);
        setQuoteList(list);
        setDetail(data);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  function parseCustomInquiryDetail(inquiryDetail, list) {
    inquiryDetail.allQuoteQty = list.filter(row => row.status !== 0).length; //总报价数
    inquiryDetail.validQuoteQty = list.filter(
      row => [1, 3, 4, 5].indexOf(row.status) !== -1
    ).length; //有效报价
    inquiryDetail.unsavedQuoXkNo = list
      .filter(row => row.status === 0)
      .map(row => row.quoXkNo)[0]; //未保存草稿报价单号
    inquiryDetail.canAdd =
      [1, 2].indexOf(inquiryDetail.status) !== -1 &&
      inquiryDetail.unsavedQuoXkNo === undefined && //未开始，报价中，且无未保存草稿。
      inquiryDetail.isSpecifyStepQuoteQty !== 1; //采购方指定阶梯报价，手机端不开放操作
    if (
      inquiryDetail.canAdd &&
      inquiryDetail.billType === 2 &&
      inquiryDetail.validQuoteQty > 0
    ) {
      //招标只能投标一次。
      inquiryDetail.canAdd = false;
    }
  }

  function handleOrder(type) {
    switch (type) {
      case 'publish':
        handlePublish(self.id);
        break;
      case 'complete':
        complete(self.id);
        break;
      case 'sendout':
        publishResult(self.id);
        break;
      case 'cancel':
        cancelList(self.id);
        break;
      case 'finish':
        finishList(self.id);
        break;
      case 'finishApply':
        finishApplyList(self.id);
        break;
      case 'quotePublish':
        quotePublish(detail.unsavedQuoXkNo);
        break;
      case 'compareStart':
        compareStart(self.id);
        break;
      default:
    }
  }

  function handle(type) {
    // switch (type) {
    //   case 'publish':
    //     this.dialogMsg = '确认发布询价/招标？';
    //     break;
    //   case 'complete':
    //     this.dialogMsg =
    //       '终止后，询价/招标结果不会发送给供应商。\n您确定要进行该操作吗？';
    //     break;
    //   case 'sendout':
    //     this.dialogMsg = '确认发布询价/招标结果？';
    //     break;
    //   case 'cancel':
    //     this.dialogMsg = '您确定取消本次询价 / 招标吗？\n取消后，将不可恢复。';
    //     break;
    //   case 'finish':
    //     this.dialogMsg = '本次询价截止时间未到，\n您确定提前结束本次询价吗？';
    //     break;
    //   case 'quotePublish':
    //     this.dialogMsg = '确认发送' + config.quoteName + '？';
    //     break;
    //   default:
    // }
    handleOrder(type);
  }

  //发布报价
  function quotePublish(quoXkNo) {
    let postbody = {
      companyCode: companyCode,
      quoXkNo: quoXkNo,
      apiPath: config.quotePublishApiPath
    };
    InquiryService.publishQuoteInquiry(
      postbody,
      data => {
        if (data?.checkResult === 'Dynamic_Inquiry_ERR_181') {
          InquiryService.publishQuoteInquiry(
            postbody,
            data2 => {
              self.getDetail();
            },
            dispatch,
            data
          );
          return;
        }
        self.getDetail();
      },
      dispatch
    );
  }

  //发布询价
  function handlePublish(inqXkNo) {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //发布询价结果
  function publishResult(inqXkNo) {
    //有比价单号，用比价的接口
    let postbody;
    if (detail.pcXkNo) {
      postbody = {
        companyCode: companyCode,
        pcXkNo: detail.pcXkNo,
        apiPath: config.puResultApiPath
      };
    } else {
      postbody = {
        companyCode: companyCode,
        inqXkNo,
        apiPath: config.puResultApiPath2
      };
    }
    InquiryService.publishInquiryResult(
      postbody,
      () => {
        if (detail.pcXkNo) {
          let url =
            '/mp/purchase/inquiry/quote-compare/detail/' +
            companyCode +
            '/' +
            detail.pcXkNo;
          setRedirect(url);
        } else {
          self.getDetail();
        }
      },
      dispatch
    );
  }

  //终止询价招标
  function complete(inqXkNo) {
    //有比价单号，用比价的接口
    let apiPath = detail.pcXkNo
      ? config.completeApiPath
      : config.completeApiPath2;
    let postbody = getPostbody(apiPath);
    InquiryService.completeInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //取消询价/招标
  function cancelList(inqXkNo) {
    let postbody = getPostbody(config.cancelApiPath);
    InquiryService.cancelInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //结束询价/招标
  function finishList(inqXkNo) {
    let postbody = getPostbody(config.finishApiPath);
    InquiryService.finishInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 结束申请
  function finishApplyList(inqXkNo) {
    let postbody = getPostbody(config.finishApplyApiPath);
    InquiryService.finishApplyInquiry(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 开始比价
  function compareStart(inqXkNo) {
    let postbody = getPostbody(config.compareStartApiPath);
    InquiryService.startPriceCompare(
      postbody,
      data => {
        if (data) {
          let url =
            '/mp/purchase/inquiry/quote-compare/detail/' +
            companyCode +
            '/' +
            data;
          setRedirect(url);
        } else {
          self.getDetail();
        }
      },
      dispatch
    );
  }

  function handleDrawer(item) {
    item.activeFlag = !item.activeFlag;
    forceUpdate();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label={detail.billTypeName} />
            {detail.status > 1 && (
              <Tab label={detail.billType === 1 ? '报价记录' : '投标记录'} />
            )}
            {((detail.status > 3 && detail.status !== 8) ||
              (detail.status === 8 && detail.billType === 1)) &&
              self.isPurchase &&
              detail.pcXkNo && <Tab label={'报价对比'} />}
            <Tab label="操作记录" />
          </Tabs>
        </Paper>
      )}
      {!self.isPurchase && detail.isSpecifyStepQuoteQty === 1 && (
        <p style={{ textAlign: 'center', color: 'red' }}>
          采购方要求按阶梯报价，请登录电脑操作
        </p>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">标题</span>
                    <div className="field-value">{detail.billTitle}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户</span>
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    </li>
                  )}
                  {detail.pcXkNo && (
                    <li>
                      <span className="field-label">比价单号</span>
                      <div className="field-value">
                        <Link
                          to={`${config.pcDetailLink}/${companyCode}/${detail.pcXkNo}`}
                        >
                          {detail.pcXkNo}
                        </Link>
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Inquiry_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  <li>
                    <span className="field-label">报价状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Quote_Status',
                            detail.qouteStatus
                          )
                        }
                      >
                        {detail.qouteStatusName}
                      </span>
                    </div>
                  </li>
                  {/* 审批流状态 仅开启后才显示 */}
                  {workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={detail.inqXkNo}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div className="field-value">
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                  <li>
                    <span className="field-label">编号</span>
                    <div className="field-value">{detail.inqXkNo}</div>
                  </li>
                  {Array.isArray(detail.productInfoMd5s) &&
                    detail.productInfoMd5s.length > 0 && (
                      <li>
                        <span className="field-label">附件</span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(68, detail)}
                          >
                            {detail.productInfoMd5s.length}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                </ul>
              </div>
            </div>
            {/* <div
              className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
              onClick={() => {
                handleMore(1);
              }}
            >
              {moreSign1 && '更多'}
              {!moreSign1 && '收起'}
              <i className="icon-down"></i>
            </div> */}
          </div>
          <div className="m-details-item">
            <div className="details-item-title">
              <label>询价/招标类型</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">类型</span>
                    <div className="field-value">
                      <span className="blue">{detail.billTypeName}</span>
                    </div>
                  </li>
                  {detail.billType === 2 && (
                    <li>
                      <span className="field-label">招标开始时间</span>
                      <div className="field-value">
                        {formatDate(detail.startDate, 'YYYY-MM-DD HH:mm:ss')}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">
                      {detail.billType === 1 ? '询价截止时间' : '招标结束时间'}
                    </span>
                    <div className="field-value">
                      {formatDate(detail.endDate, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>

                  {!self.isPurchase && detail.showedVendorFlag === 1 && (
                    <li>
                      <span className="field-label">物料使用客户</span>
                      <div className="field-value">
                        {detail.usedByCustomerInnerCode
                          ? '(' + detail.usedByCustomerInnerCode + ')'
                          : ''}
                        {detail.usedByCustomerInnerName}
                      </div>
                    </li>
                  )}
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">物料使用客户</span>
                      <div className="field-value">
                        <span>
                          {detail.usedByCustomerInnerCode
                            ? '(' + detail.usedByCustomerInnerCode + ')'
                            : ''}
                          {detail.usedByCustomerInnerName}
                        </span>
                        <div>
                          <FormControlLabel
                            disabled
                            control={
                              <Checkbox
                                checked={
                                  detail.showedVendorFlag === 1 ? true : false
                                }
                              />
                            }
                            label="是否显示给供应商"
                          />
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/* 单头自定义 */}
          <div className="m-details-item">
            <HeadCustField
              fieldSetting={fieldSetting1}
              detail={detail}
              setDetail={setDetail}
              isPurchase={self.isPurchase}
            ></HeadCustField>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>{detail.billTypeName}物料</label>
            </div>
            <div className="details-item-content">
              {detail?.prodList?.length > 0 &&
                detail?.prodList.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(item.id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次 {item.lineNo}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">物料编码</span>
                        <div className="field-value">{item.productCode}</div>
                      </li>
                      <li>
                        <span className="field-label">物料名称</span>
                        <div className="field-value">{item.productName}</div>
                      </li>
                      <li>
                        <span className="field-label">物料规格</span>
                        <div className="field-value">{item.productScale}</div>
                      </li>
                      <li>
                        <span className="field-label">采购数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.purchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}{' '}
                          {item.purchaseUnitName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">采购单位</span>
                        <div className="field-value">{item.unitName}</div>
                      </li>
                      {self.isPurchase && (
                        <li>
                          <span className="field-label">期望价格</span>
                          <div className="field-value">
                            {item.expectedPrice
                              ? formatNumber(
                                  item.expectedPrice,
                                  decimalPlace.Price_Decimal_Place
                                ) + '元'
                              : ''}
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">上限价格</span>
                        <div className="field-value">
                          {item.upperLimitPrice
                            ? formatNumber(
                                item.upperLimitPrice,
                                decimalPlace.Price_Decimal_Place
                              ) + '元'
                            : ''}
                        </div>
                      </li>
                      {item.descTag !== 1 && (
                        <li>
                          <span className="field-label">相关说明</span>
                          <div className="field-value">{item.description}</div>
                        </li>
                      )}
                      {item.descTag === 1 && (
                        <li>
                          <span className="field-label">相关说明</span>
                          <div className="field-value">
                            {item.descriptionList.map((val, i) => (
                              <div key={i}>
                                {val.title}: {val.text}
                              </div>
                            ))}
                          </div>
                        </li>
                      )}
                      {Array.isArray(item.fileMd5s) &&
                        item.fileMd5s.length > 0 && (
                          <li>
                            <span className="field-label">图纸/文档</span>
                            <div className="field-value">
                              <span
                                className="attachment"
                                onClick={() => showFileList(119, item)}
                              >
                                {item.fileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                            </div>
                          </li>
                        )}
                      {item.printExtendFields !== '' && (
                        <li>
                          <span className="field-label">采购说明</span>
                          <div className="field-value">
                            {item.printExtendFields}
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">备注</span>
                        <div className="field-value">{item.remark}</div>
                      </li>
                    </ul>
                    {/* 单身自定义字段 */}
                    <BodydCustField
                      fieldSetting={fieldSetting1}
                      line={item}
                      isPurchase={self.isPurchase}
                    ></BodydCustField>
                  </div>
                ))}
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>{detail.billTypeName}说明</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">付款方式</span>
                    <div className="field-value">{detail.payWayName}</div>
                  </li>
                  <li>
                    <span className="field-label">付款周期</span>
                    <div className="field-value">{detail.paymentCycleName}</div>
                  </li>
                  <li>
                    <span className="field-label">说明</span>
                    <div className="field-value">{detail.description}</div>
                  </li>
                  {Array.isArray(detail.fileMd5s) &&
                    detail.fileMd5s.length > 0 && (
                      <li>
                        <span className="field-label">
                          {detail.billTypeName}文件
                        </span>
                        <div className="field-value">
                          <span
                            className="attachment"
                            onClick={() => showFileList(11, detail)}
                          >
                            {detail.fileMd5s.length}个附件
                            <i className="icon-attachment"></i>
                          </span>
                        </div>
                      </li>
                    )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>报价要求</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">报价币别</span>
                    <div className="field-value">
                      {detail.quoteCurrencyName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">是否含税</span>
                    <div className="field-value">
                      {detail.priceContainTaxName}
                    </div>
                  </li>
                  {detail.priceContainTaxFlag && detail.taxRate ? (
                    <li>
                      <span className="field-label">税率</span>
                      <div className="field-value">{detail.taxRate}%</div>
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              </div>
            </div>
          </div>
          {self.isPurchase && (
            <div className="m-details-item">
              <div className="details-item-title">
                <label>邀请供应商</label>
              </div>
              <div className="details-item-content">
                {detail?.vendorList?.length > 0 &&
                  detail.vendorList?.map((item, index) => (
                    <div className="content-line line-list-item" key={index}>
                      <ul className="field-list">
                        <li>
                          <span className="field-label">类型</span>
                          <div className="field-value">
                            <span>
                              {detail.quoteRangeType === 1
                                ? '仅限指定供应商'
                                : '公开' + detail.billTypeName}
                            </span>
                          </div>
                        </li>
                        <li>
                          <span className="field-label">供应商</span>
                          <div className="field-value">
                            {item.innerVendorCode}-{item.innerVendorName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台状态</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2 ? '已加入' : '未加入'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">接收人</span>
                          <div className="field-value">
                            {item.contactPerson}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">手机号码</span>
                          <div className="field-value">
                            {item.mobile ? item.mobileArea : ''} {item.mobile}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">邮箱</span>
                          <div className="field-value">{item.mailbox}</div>
                        </li>
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <Paper elevation={0} square style={{ padding: '10px 10px 70px' }}>
          {self.isPurchase ? (
            <div>
              <SearchBar
                placeholder="供应商名称/编码"
                onSubmit={handleSearch}
                onClear={handleSearch}
              />
              {takeNotesList1.map((item, index) => (
                // <Link
                //   to={`${config.detailLink}/${companyCode}/${item.inqXkNo}/${item.quoInnerNo}`}
                //   key={index}
                //   className="m-list-item"
                // >
                <MediaBox className="m-list-item" key={index}>
                  <h4>
                    <span className="list-index">{index + 1}</span>
                    {item.innerVendorName}
                  </h4>
                  <ul className="clearfix main">
                    <li>
                      <label>供应商编码：</label>
                      <div>{item.innerVendorCode}</div>
                    </li>
                    <li>
                      <label>{config.quoteName}单号：</label>
                      <div>
                        {detail.billType !== 2 && (
                          <Link
                            to={`${config.detailLink}/${companyCode}/${item.inqXkNo}/${item.quoInnerNo}`}
                            key={index}
                          >
                            <span className="blue">{item.quoInnerNo}</span>
                          </Link>
                        )}
                        {detail.billType === 2 &&
                          (![2, 8, 9].includes(detail.status) ||
                            ([2, 8, 9].includes(detail.status) &&
                              item.status === 2)) && (
                            <Link
                              to={`${config.detailLink}/${companyCode}/${item.inqXkNo}/${item.quoInnerNo}`}
                              key={index}
                            >
                              <span className="blue">{item.quoInnerNo}</span>
                            </Link>
                          )}
                        {detail.billType === 2 &&
                          !(
                            ![2, 8, 9].includes(detail.status) ||
                            ([2, 8, 9].includes(detail.status) &&
                              item.status === 2)
                          ) && <span>{item.quoInnerNo}</span>}
                      </div>
                      {/* <div className="blue">{item.quoInnerNo}</div> */}
                    </li>
                    <li>
                      <label>{config.quoteName}时间：</label>
                      <div>{formatDate(item.quoteTime)}</div>
                    </li>
                    <li>
                      <label>{config.quoteName}人：</label>
                      <div>{item.quoteName}</div>
                    </li>
                  </ul>
                  <ul className="usually">
                    <li
                      className={
                        'u-sign ' +
                        ([4, 5].indexOf(item.status) > -1
                          ? 'green'
                          : [3].indexOf(item.status) > -1
                          ? 'red'
                          : '')
                      }
                    >
                      {item.statusName}
                    </li>
                  </ul>
                </MediaBox>
                // </Link>
              ))}
              {takeNotesList1.length === 0 && (
                <LoadMore showLine> 暂无数据</LoadMore>
              )}
            </div>
          ) : (
            <div>
              {quoteList.map((item, index) => (
                <Link
                  to={`${config.detailLink}/${companyCode}/${item.inqXkNo}/${item.quoInnerNo}`}
                  key={item.id}
                  className="m-list-item"
                >
                  <MediaBox>
                    <h4>
                      <span className="list-index">{index + 1}</span>
                      {item.quoInnerNo}
                    </h4>
                    <ul className="clearfix main">
                      <li>
                        <label>{config.quoteName}时间：</label>
                        <div>{formatDate(item.quoteTime)}</div>
                      </li>
                      <li>
                        <label>{config.quoteName}人：</label>
                        <div>{item.quoteName}</div>
                      </li>
                      <li>
                        <label>退回原因：</label>
                        <div>{item.rejectReason}</div>
                      </li>
                    </ul>
                    <ul className="usually">
                      <li
                        className={
                          'u-sign ' +
                          ([4, 5].indexOf(item.status) > -1
                            ? 'green'
                            : [2, 3].indexOf(item.status) > -1
                            ? 'red'
                            : '')
                        }
                      >
                        {item.statusName}
                      </li>
                    </ul>
                  </MediaBox>
                </Link>
              ))}
              {quoteList.length === 0 && (
                <LoadMore showLine> 暂无数据</LoadMore>
              )}
            </div>
          )}
        </Paper>
      )}
      {currNavIndex === 2 && detail.quoteCompareList && (
        <div>
          <PriceCompare
            doubleInquiryFlag={detail.doubleInquiryFlag}
            prodList={detail.quoteCompareList}
            companyCode={companyCode}
            decimalPlace={decimalPlace}
            handleDrawer={data => handleDrawer(data)}
          ></PriceCompare>
          {(self.isPurchase || (!self.isPurchase && detail.isSyncSummary)) && (
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>{detail.billTypeName}项目总结：</label>
              </div>
              <p className="wrap">
                <span className="quoProductsList clearfix">
                  {detail.biddingSummary}
                </span>{' '}
              </p>
            </div>
          )}
        </div>
      )}
      {currNavIndex ===
        (((detail.status > 3 && detail.status !== 8) ||
          (detail.status === 8 && detail.billType === 1)) &&
        self.isPurchase &&
        detail.pcXkNo
          ? 3
          : 2) && (
        <OrderLogList
          billNo={self.id}
          companyCode={companyCode}
          customerCode={!self.isPurchase ? detail.customerCode : undefined}
        ></OrderLogList>
      )}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10050307') &&
            detail.status === 0 &&
            workflow.data &&
            workflow.data[
              detail.billType === 1 ? 'inqu_publish_2' : 'bid_publish_2'
            ].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('publish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
          {User.checkAuth('10050306') &&
            detail.status === 4 &&
            !detail.pcXkNo && (
              <Button
                type="default"
                onClick={() => {
                  handle('complete');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                终止{detail.billTypeName}
              </Button>
            )}
          {/* {User.checkAuth('10050306') &&
            detail.status === 7 &&
            workflow.data &&
            workflow.data[detail.billType === 1 ? 'inqu_cfm_5' : 'bid_cfm_5']
              .complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('sendout');
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                发布结果
              </Button>
            )} */}
          {User.checkAuth('10050303') && detail.status === 2 && (
            <Button
              type="default"
              onClick={() => {
                handle('cancel');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              取消{detail.billTypeName}
            </Button>
          )}

          {User.checkAuth('10050303') &&
            detail.status === 14 &&
            (workflow?.data?.inq_finish_4?.complete ||
              workflow?.data?.tender_finish_4?.complete) && (
              <Button
                type="default"
                onClick={() => {
                  handle('finish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                结束{detail.billTypeName}
              </Button>
            )}

          {User.checkAuth('10050303') &&
            detail.status === 2 &&
            !(
              workflow?.data?.inq_finish_4?.wfNodeList?.length ||
              workflow?.data?.tender_finish_4?.wfNodeList?.length
            ) && (
              <Button
                type="default"
                onClick={() => {
                  handle('finish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                结束{detail.billTypeName}
              </Button>
            )}

          {User.checkAuth('10050303') &&
            detail.status === 2 &&
            (workflow?.data?.inq_finish_4?.wfNodeList?.length ||
              workflow?.data?.tender_finish_4?.wfNodeList?.length) && (
              <Button
                type="default"
                onClick={() => {
                  handle('finishApply');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                结束申请
              </Button>
            )}
          {detail.status === 8 &&
            ((User.checkAuth('10050316') &&
              detail.billType === 1 &&
              workflow?.data?.inq_price_compare_4?.complete) ||
              (User.checkAuth('10050316') &&
                detail.billType === 2 &&
                workflow?.data?.tender_price_compare_4?.complete)) && (
              <Button
                type="default"
                onClick={() => {
                  handle('compareStart');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                开始比价
              </Button>
            )}
        </div>
      )}
      {!self.isPurchase && User.checkAuth('20050302') && (
        <div className="wrap m-flex-box fixed-bottom">
          {detail.canAdd && (
            <Button
              href={`${config.addLink}/${companyCode}/${self.id}`}
              type="default"
              className="m-flex-item u-btn u-btn_primary"
            >
              {quoteList.length === 0 ? '开始' : '重新'}
              {config.quoteName}
            </Button>
          )}
          {detail.unsavedQuoXkNo && (
            <Button
              type="default"
              onClick={() => {
                handle('quotePublish');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              发送{config.quoteName}
            </Button>
          )}
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

InquiryDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryDetail);
